export const API_URL = import.meta.env.VITE_API_URL;
export const PASSWORD = import.meta.env.VITE_PASSWORD;
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const STAGE = ENVIRONMENT === "staging" ? "dev" : "prod";
